import { MeshMaterial } from 'pixijs/mesh';

import type { CanvasRenderer } from 'pixijs/renderer/canvas';
import type { Mesh } from 'pixijs/mesh';

/**
 * Renders the mesh using the Canvas renderer
 * @protected
 * @method render
 * @memberof PIXI.MeshMaterial#
 * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
 * @param {PIXI.Mesh} mesh - Mesh to render.
 */
MeshMaterial.prototype._renderCanvas = function _renderCanvas(renderer: CanvasRenderer, mesh: Mesh): void
{
    renderer.plugins.mesh.render(mesh);
};
